import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img3 from "../../../assets/img/warehouseStructure/warehouseNine/img3.webp";

function WarehouseNine(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={300}>
            <div className={`warehouseNine ${isVisible ? 'visible' : ''}`}>
                <div className="nineText">
                    <h1 className={`${isVisible ? 'visible' : ''}`}><span>{t("warehouse_nine_title_span")}</span><br />{t("warehouse_nine_title")}</h1>
                    <p className={`${isVisible ? 'visible' : ''}`}>
                        {t("warehouse_nine_text")}
                    </p>
                </div>
                <div className="nineImg">
                    <img className={`img1 ${isVisible ? 'visible' : ''}`} src={img3} alt="" width={'600px'}/>
                </div>
            </div>
        </VisibilitySensor>
    )
}
export default WarehouseNine;
